"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3784],{

/***/ 9296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function ItemNotFound() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
        h: "50vh",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
            children: locale == "id" ? "Tidak Ditemukan." : "Not Found."
        })
    });
};


/***/ }),

/***/ 3784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SectionOffer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/utils/hooks.js + 1 modules
var hooks = __webpack_require__(1127);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js + 1 modules
var esm = __webpack_require__(9996);
// EXTERNAL MODULE: ./src/utils/const.js
var utils_const = __webpack_require__(3026);
;// CONCATENATED MODULE: ./src/components/DetailGroupPopup.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











function DetailGroupPopup(param) {
    var id = param.id, setIsGroupPop = param.setIsGroupPop, _isGroupOffer = param.isGroupOffer, isGroupOffer = _isGroupOffer === void 0 ? true : _isGroupOffer, hotelName = param.hotelName, _color = param.color, color = _color === void 0 ? "black" : _color;
    var router = (0,next_router.useRouter)();
    var locale = (0,hooks/* useLocale */.bU)();
    var ref5 = _slicedToArray((0,hooks/* useFetchSWRv2 */.bX)("special_offers", {
        _ID: id,
        cct_status: "publish"
    }), 2), data = ref5[0], isLoading = ref5[1];
    var hotels = (0,hooks/* useGetListHotel */.e7)().hotels;
    var optionRef = (0,react.useRef)(null);
    var popRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), showOptions = ref1[0], setShowOptions = ref1[1];
    var ref2 = (0,react.useState)(), hotelCode = ref2[0], setHotelCode = ref2[1];
    (0,react.useEffect)(function() {
        if (hotels && !isGroupOffer) {
            var x = hotels.filter(function filterHotel(hotel) {
                if (hotel.name == hotelName) {
                    return true;
                }
                return false;
            });
            setHotelCode(x[0].hotel_code);
        }
    }, [
        hotels
    ]);
    (0,dist/* useOutsideClick */.O3d)({
        ref: optionRef,
        handler: function() {
            return setShowOptions(false);
        }
    });
    (0,dist/* useOutsideClick */.O3d)({
        ref: popRef,
        handler: function() {
            return setIsGroupPop(false);
        }
    });
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 5,
        bg: "blackAlpha.600",
        h: "100vh",
        w: "100vw",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AbsoluteCenter */.umj, {
            ref: popRef,
            w: [
                "90vw",
                "70vw",
                "75vw"
            ],
            h: [
                "min(100%, 75vh)"
            ],
            overflowY: "hidden",
            bg: "white",
            borderRadius: 0,
            zIndex: 6,
            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                w: "100%",
                h: "100%",
                gap: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Spinner */.$jN, {
                    color: "black",
                    size: "xl"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Center */.M5Y, {
                w: "100%",
                h: "100%",
                gap: 10,
                position: "relative",
                p: 10,
                flexDir: {
                    base: "column",
                    lg: "row"
                },
                overflowY: "scroll",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        position: "absolute",
                        right: 0,
                        top: -10,
                        color: "white",
                        cursor: "pointer",
                        onClick: function() {
                            return setIsGroupPop(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoClose */.bjh, {
                            size: 32
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        w: {
                            base: "full",
                            lg: "35%"
                        },
                        h: "full",
                        flexDir: "column",
                        gap: 5,
                        color: "blackAlpha.700",
                        fontSize: "sm",
                        my: [
                            6,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                        fontSize: "2xl",
                                        letterSpacing: "widest",
                                        fontWeight: 400,
                                        mb: 2,
                                        children: data[0].title
                                    }),
                                    data[0].start_from > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                        mb: 2,
                                        children: [
                                            locale == "id" ? "Harga mulai" : "Start from",
                                            " ",
                                            data[0].start_from && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (0,functions/* formatRupiah */.b7)(data[0].start_from)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Markup */.Lu, {
                                    className: "white-space-enter",
                                    content: locale == "id" ? (ref3 = data[0].desc_long_id.replace(/\\n/g, "<br>")) !== null && ref3 !== void 0 ? ref3 : "" : (ref4 = data[0].desc_long.replace(/\\n/g, "<br>")) !== null && ref4 !== void 0 ? ref4 : ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        fontWeight: 500,
                                        children: locale == "id" ? "Keuntungan" : "Benefits"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* UnorderedList */.QI$, {
                                        display: "flex",
                                        flexDir: "column",
                                        gap: 0,
                                        children: locale == "id" ? (0,functions/* objParserWP */.aG)(data[0].benefits_id, "benefit").map(function(v) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ListItem */.HCh, {
                                                pl: 2,
                                                ml: 1,
                                                children: v
                                            }, v);
                                        }) : (0,functions/* objParserWP */.aG)(data[0].benefits, "benefit").map(function(v) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ListItem */.HCh, {
                                                pl: 2,
                                                ml: 1,
                                                children: v
                                            }, v);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                align: "center",
                                gap: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: locale == "id" ? "Tersedia: " : "Available: "
                                        }),
                                        data[0].date_start && data[0].date_end ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: (0,functions/* getAvailDate */.K6)([
                                                data[0].date_start,
                                                data[0].date_end
                                            ].map(function(x) {
                                                return (0,functions/* timeConvertion */.mQ)({
                                                    UNIX_timestamp: x,
                                                    months: locale == "id" ? utils_const/* monthId */.Cf : utils_const/* monthEn */.Ic
                                                });
                                            }))
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: "-"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                gap: 4,
                                pb: 6,
                                children: [
                                    data[0].start_from > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                        position: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Button */.zxk, {
                                                variant: "dark",
                                                bg: color,
                                                mb: [
                                                    6,
                                                    6,
                                                    8,
                                                    10
                                                ],
                                                onClick: function() {
                                                    isGroupOffer ? setShowOptions(!showOptions) : data[0].connect_to_synxis == "false" ? window.open(data[0].promo_url, "_blank") : function() {
                                                        var targetCode = hotelCode;
                                                        var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                        var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                        var _arrive, _rate, _promo, _coupon;
                                                        (0,functions/* submitBookingEngineForm */.Sw)({
                                                            action: action,
                                                            fields: {
                                                                language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                arrivalDate: (_arrive = data[0].arrive) !== null && _arrive !== void 0 ? _arrive : "",
                                                                nights: (0,functions/* getBookingEngineNights */.cl)(data[0].arrive, data[0].depart),
                                                                guestCountSelector: "ReadOnly",
                                                                crossSell: "false",
                                                                selectedAdultCount: "2",
                                                                rate: (_rate = data[0].rate) !== null && _rate !== void 0 ? _rate : "",
                                                                promo: (_promo = data[0].promo) !== null && _promo !== void 0 ? _promo : "",
                                                                coupon: (_coupon = data[0].coupon) !== null && _coupon !== void 0 ? _coupon : ""
                                                            }
                                                        });
                                                    }();
                                                },
                                                children: [
                                                    locale == "id" ? "Pesan" : "Book Now",
                                                    isGroupOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronDown */.CgR, {
                                                        style: {
                                                            marginLeft: 4
                                                        },
                                                        size: 14
                                                    })
                                                ]
                                            }),
                                            hotels && isGroupOffer && showOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                ref: optionRef,
                                                position: "absolute",
                                                left: 0,
                                                top: 12,
                                                flexDir: "column",
                                                bg: "white",
                                                className: "header-box-shadows",
                                                gap: 2,
                                                p: 3,
                                                overflowY: "scroll",
                                                maxH: 200,
                                                children: data[0].hotel_names ? data[0].hotel_names.map(function(name) {
                                                    var tempHotel = (0,lodash.filter)(hotels, function(o) {
                                                        return o.name == name;
                                                    });
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                as: "span",
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: function() {
                                                                    setShowOptions(false);
                                                                    data[0].connect_to_synxis == "false" ? window.open(data[0].promo_url, "_blank") : function() {
                                                                        var ref;
                                                                        var targetCode = (ref = tempHotel[0]) === null || ref === void 0 ? void 0 : ref.hotel_code;
                                                                        var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                                        var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                        var _arrive, _rate, _promo, _coupon;
                                                                        (0,functions/* submitBookingEngineForm */.Sw)({
                                                                            action: action,
                                                                            fields: {
                                                                                language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                                arrivalDate: (_arrive = data[0].arrive) !== null && _arrive !== void 0 ? _arrive : "",
                                                                                nights: (0,functions/* getBookingEngineNights */.cl)(data[0].arrive, data[0].depart),
                                                                                guestCountSelector: "ReadOnly",
                                                                                crossSell: "false",
                                                                                selectedAdultCount: "2",
                                                                                rate: (_rate = data[0].rate) !== null && _rate !== void 0 ? _rate : "",
                                                                                promo: (_promo = data[0].promo) !== null && _promo !== void 0 ? _promo : "",
                                                                                coupon: (_coupon = data[0].coupon) !== null && _coupon !== void 0 ? _coupon : ""
                                                                            }
                                                                        });
                                                                    }();
                                                                },
                                                                children: name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                                    orientation: "horizontal"
                                                                })
                                                            })
                                                        ]
                                                    }, name);
                                                }) : hotels.map(function(hotel) {
                                                    var tempHotel = JSON.stringify(hotel);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                as: "span",
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: function() {
                                                                    setShowOptions(false);
                                                                    data[0].connect_to_synxis == "false" ? window.open(data[0].promo_url, "_blank") : function() {
                                                                        var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(hotel.hotel_code);
                                                                        var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                        var _arrive, _rate, _promo, _coupon;
                                                                        (0,functions/* submitBookingEngineForm */.Sw)({
                                                                            action: action,
                                                                            fields: {
                                                                                language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                                arrivalDate: (_arrive = data[0].arrive) !== null && _arrive !== void 0 ? _arrive : "",
                                                                                nights: (0,functions/* getBookingEngineNights */.cl)(data[0].arrive, data[0].depart),
                                                                                guestCountSelector: "ReadOnly",
                                                                                crossSell: "false",
                                                                                selectedAdultCount: "2",
                                                                                rate: (_rate = data[0].rate) !== null && _rate !== void 0 ? _rate : "",
                                                                                promo: (_promo = data[0].promo) !== null && _promo !== void 0 ? _promo : "",
                                                                                coupon: (_coupon = data[0].coupon) !== null && _coupon !== void 0 ? _coupon : ""
                                                                            }
                                                                        });
                                                                    }();
                                                                },
                                                                children: hotel.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                                    orientation: "horizontal"
                                                                })
                                                            })
                                                        ]
                                                    }, hotel.name);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                        variant: "outlineWhite",
                                        color: color,
                                        borderColor: color,
                                        onClick: function() {
                                            return router.push("/special-offers/".concat(id));
                                        },
                                        children: locale == "id" ? "Detail" : "Details"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        w: {
                            base: "full",
                            lg: "65%"
                        },
                        h: {
                            base: "500px",
                            lg: "full"
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: data[0].thumb,
                            alt: "",
                            layout: "fill",
                            objectFit: "cover",
                            priority: true,
                            unoptimized: true
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/ItemNotFound.tsx
var ItemNotFound = __webpack_require__(9296);
// EXTERNAL MODULE: ./src/components/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(8506);
;// CONCATENATED MODULE: ./src/components/special-offers/SectionOffer.jsx
function SectionOffer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SectionOffer_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SectionOffer_arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SectionOffer_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SectionOffer_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SectionOffer_slicedToArray(arr, i) {
    return SectionOffer_arrayWithHoles(arr) || SectionOffer_iterableToArrayLimit(arr, i) || SectionOffer_unsupportedIterableToArray(arr, i) || SectionOffer_nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || SectionOffer_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function SectionOffer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SectionOffer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SectionOffer_arrayLikeToArray(o, minLen);
}















function SectionOffer(param1) {
    var isGroupOffer = param1.isGroupOffer, _limit = param1.limit, limit = _limit === void 0 ? 3 : _limit, _isMainPage = param1.isMainPage, isMainPage = _isMainPage === void 0 ? false : _isMainPage, _hotel = param1.hotel, hotel = _hotel === void 0 ? "parador" : _hotel, _color = param1.color, color = _color === void 0 ? "black" : _color, _isParador = param1.isParador, isParador = _isParador === void 0 ? true : _isParador, hotelCode = param1.hotelCode;
    var router = (0,next_router.useRouter)();
    var locale = (0,hooks/* useLocale */.bU)();
    var ref = SectionOffer_slicedToArray((0,react.useState)(null), 2), selectedCat = ref[0], setSelectedCat = ref[1];
    var params = isParador ? {
        _limit: limit ? limit : 0,
        cct_status: "publish",
        is_group_offer: isGroupOffer,
        is_private: "false"
    } : {
        _limit: limit ? limit : 0,
        cct_status: "publish",
        hotel_name: hotel,
        is_group_offer: isGroupOffer,
        is_private: "false"
    };
    var ref1 = SectionOffer_slicedToArray((0,hooks/* useFetchSWRv2 */.bX)("special_offers", _objectSpread({}, params, selectedCat && selectedCat != "selected" && {
        category: selectedCat
    }, selectedCat == "selected" && {
        _limit: 0
    })), 3), offersData = ref1[0], isLoading = ref1[1], isError = ref1[2];
    var ref2 = SectionOffer_slicedToArray((0,react.useState)(null), 2), data1 = ref2[0], setData = ref2[1];
    var ref3 = SectionOffer_slicedToArray((0,react.useState)(false), 2), dataLoading = ref3[0], setDataLoading = ref3[1];
    (0,react.useEffect)(function() {
        function f() {
            return _f.apply(this, arguments);
        }
        function _f() {
            _f = _asyncToGenerator(runtime_default().mark(function _callee() {
                var dataFilter, rawData, temp;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setDataLoading(true);
                            _ctx.t0 = lodash.filter;
                            _ctx.next = 4;
                            return offersData;
                        case 4:
                            _ctx.t1 = _ctx.sent;
                            _ctx.t2 = function(data) {
                                return new Date(data.date_end * 1000) >= new Date();
                            };
                            dataFilter = (0, _ctx.t0)(_ctx.t1, _ctx.t2);
                            _ctx.next = 9;
                            return dataFilter;
                        case 9:
                            if (!_ctx.sent) {
                                _ctx.next = 11;
                                break;
                            }
                            {
                                rawData = (0,lodash.filter)(dataFilter, function(o) {
                                    return o.is_private != "true";
                                });
                                if (isParador) {
                                    setData(rawData);
                                } else {
                                    temp = (0,lodash.filter)(rawData, function(o) {
                                        return o.hotel_name != "Parador";
                                    });
                                    setData(temp);
                                }
                            }
                        case 11:
                            setDataLoading(false);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _f.apply(this, arguments);
        }
        f();
    }, [
        isParador,
        offersData,
        selectedCat
    ]);
    (0,react.useEffect)(function() {
        !isGroupOffer && setSelectedCat("selected");
    }, []);
    (0,react.useEffect)(function() {
        function f() {
            return _f.apply(this, arguments);
        }
        function _f() {
            _f = _asyncToGenerator(runtime_default().mark(function _callee() {
                var dataFilter, temp, temp2;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setDataLoading(true);
                            _ctx.t0 = lodash.filter;
                            _ctx.next = 4;
                            return offersData;
                        case 4:
                            _ctx.t1 = _ctx.sent;
                            _ctx.t2 = function(data) {
                                return new Date(data.date_end * 1000) >= new Date();
                            };
                            dataFilter = (0, _ctx.t0)(_ctx.t1, _ctx.t2);
                            _ctx.next = 9;
                            return dataFilter;
                        case 9:
                            if (!_ctx.sent) {
                                _ctx.next = 11;
                                break;
                            }
                            {
                                if (selectedCat == "selected") {
                                    temp = (0,lodash.filter)(dataFilter, function(o) {
                                        return o.is_selected == "true";
                                    });
                                    temp2 = temp.concat(dataFilter);
                                    temp2 = _toConsumableArray(new Set(_toConsumableArray(temp).concat(_toConsumableArray(dataFilter))));
                                    setData(limit ? temp2.slice(0, limit) : temp2);
                                }
                            }
                        case 11:
                            setDataLoading(false);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _f.apply(this, arguments);
        }
        f();
    }, [
        isGroupOffer,
        offersData,
        selectedCat
    ]);
    var isLarge = (0,mediaQuery/* useLargeQuery */.fc)().isLarge;
    (0,react.useEffect)(function() {
        data1 && setViewAs(data1.length > 2 || !isLarge ? "grid" : "list");
    }, [
        data1,
        isLarge
    ]);
    var ref4 = SectionOffer_slicedToArray((0,react.useState)(null), 2), viewAs = ref4[0], setViewAs = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
        variant: "flat",
        bg: "white",
        overflowX: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                justify: "space-between",
                gap: 3,
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        mb: 2,
                        as: "h1",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        color: color,
                        fontSize: [
                            "xl",
                            "2xl",
                            "2xl",
                            "3xl"
                        ],
                        // whiteSpace={["unset", null, null, "nowrap"]}
                        whiteSpace: "nowrap",
                        children: isGroupOffer ? locale == "id" ? "Penawaran Grup" : "Group Offers" : locale == "id" ? "Penawaran Hotel" : "Hotel Offers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        color: "blackAlpha.600",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                onClick: function() {
                                    return setViewAs("list");
                                },
                                cursor: "pointer",
                                display: [
                                    "none",
                                    null,
                                    null,
                                    "block"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoListOutline */.mKE, {
                                    color: viewAs === "list" ? color : "inherit",
                                    size: 28
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                onClick: function() {
                                    return setViewAs("grid");
                                },
                                cursor: "pointer",
                                display: [
                                    "none",
                                    null,
                                    null,
                                    "block"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoGridOutline */.zrF, {
                                    color: viewAs === "grid" ? color : "inherit",
                                    size: 22
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                h: "20px",
                                display: [
                                    "none",
                                    null,
                                    null,
                                    "block"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                    borderColor: "blackAlpha.500",
                                    opacity: 1,
                                    orientation: "vertical"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Select */.PhF, {
                                fontSize: "sm",
                                border: "none",
                                _focus: {},
                                value: selectedCat !== null && selectedCat !== void 0 ? selectedCat : "all",
                                onChange: function(e) {
                                    setSelectedCat(e.target.value == "all" ? null : e.target.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "all",
                                        children: locale == "id" ? "TERBARU" : "LATEST"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "foods",
                                        children: locale == "id" ? "MAKANAN & MINUMAN" : "FOODS & BEVERAGES"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "partnership",
                                        children: locale == "id" ? "KEMITRAAN" : "PARTNERSHIP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "room",
                                        children: locale == "id" ? "KAMAR" : "ROOMS"
                                    }),
                                    !isGroupOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "selected",
                                        children: locale == "id" ? "PILIHAN" : "SELECTED"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isLoading || dataLoading || !viewAs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {}) : data1 && data1.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    viewAs === "grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
                        columns: [
                            1,
                            1,
                            2,
                            2,
                            3
                        ],
                        spacing: [
                            12,
                            10,
                            8
                        ],
                        children: data1 ? data1.map(function(param, i) {
                            var thumb = param.thumb, title = param.title, title_id = param.title_id, desc_short = param.desc_short, desc_short_id = param.desc_short_id, start_from = param.start_from, hotel_name = param.hotel_name, hotel_names = param.hotel_names, _ID = param._ID, rate = param.rate, promo = param.promo, connect_to_synxis = param.connect_to_synxis, promo_url = param.promo_url, coupon = param.coupon, dest = param.dest, arrive = param.arrive, depart = param.depart, category = param.category;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCardGrid, {
                                img: thumb,
                                title: locale == "id" ? title_id !== null && title_id !== void 0 ? title_id : title : title,
                                desc: locale == "id" ? desc_short_id : desc_short,
                                hotel: isGroupOffer ? hotel_names : hotel_name,
                                price: start_from,
                                isGroupOffer: isGroupOffer,
                                id: _ID,
                                color: color,
                                isParador: isParador,
                                hotelCode: hotelCode,
                                rate: rate,
                                promo: promo,
                                connect_to_synxis: connect_to_synxis,
                                promo_url: promo_url,
                                coupon: coupon,
                                dest: dest,
                                arrive: arrive,
                                depart: depart,
                                category: category
                            }, i);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNotFound/* default */.Z, {})
                    }),
                    viewAs === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        direction: "column",
                        gap: [
                            6,
                            12
                        ],
                        children: data1 && !isError && !isLoading && data1.map(function(param, i) {
                            var thumb = param.thumb, thumb_list = param.thumb_list, title = param.title, title_id = param.title_id, desc_short = param.desc_short, desc_short_id = param.desc_short_id, start_from = param.start_from, hotel_name = param.hotel_name, _ID = param._ID, rate = param.rate, promo = param.promo, hotel_names = param.hotel_names, connect_to_synxis = param.connect_to_synxis, promo_url = param.promo_url, coupon = param.coupon, dest = param.dest, arrive = param.arrive, depart = param.depart, category = param.category;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCardList, {
                                img: thumb,
                                thumb_list: thumb_list,
                                title: locale == "id" ? title_id !== null && title_id !== void 0 ? title_id : title : title,
                                desc: locale == "id" ? desc_short_id : desc_short,
                                hotel: isGroupOffer ? hotel_names : hotel_name,
                                price: start_from,
                                isGroupOffer: isGroupOffer,
                                id: _ID,
                                color: color,
                                isParador: isParador,
                                hotelCode: hotelCode,
                                rate: rate,
                                promo: promo,
                                connect_to_synxis: connect_to_synxis,
                                promo_url: promo_url,
                                coupon: coupon,
                                dest: dest,
                                arrive: arrive,
                                depart: depart,
                                category: category
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNotFound/* default */.Z, {}),
            !isMainPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                mt: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                    variant: "dark",
                    size: "md",
                    onClick: function() {
                        router.push("/special-offers/".concat(isGroupOffer ? "group" : "hotels"));
                    },
                    children: locale == "id" ? "Lebih Banyak" : "Load More"
                })
            })
        ]
    });
};
function OfferCardGrid(param) {
    var img = param.img, title = param.title, price = param.price, desc = param.desc, hotel1 = param.hotel, isGroupOffer = param.isGroupOffer, id = param.id, color = param.color, isParador = param.isParador, hotelCode = param.hotelCode, rate = param.rate, promo = param.promo, connect_to_synxis = param.connect_to_synxis, promo_url = param.promo_url, coupon = param.coupon, dest = param.dest, arrive = param.arrive, depart = param.depart, category = param.category;
    var router = (0,next_router.useRouter)();
    var locale = (0,hooks/* useLocale */.bU)();
    var ref7 = (0,react.useState)(false), isGroupPop1 = ref7[0], setIsGroupPop = ref7[1];
    var hotels = (0,hooks/* useGetListHotel */.e7)().hotels;
    var optionRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: optionRef,
        handler: function() {
            return setShowOptions(false);
        }
    });
    var ref5 = (0,react.useState)(false), showOptions = ref5[0], setShowOptions = ref5[1];
    var ref6 = (0,react.useState)(), hotelCode2 = ref6[0], setHotelCode2 = ref6[1];
    (0,react.useEffect)(function() {
        if (isGroupOffer || !isParador || !hotels) return;
        var tempHotel = (0,lodash.filter)(hotels, function(o) {
            return o.name == hotel1;
        });
        setHotelCode2(tempHotel[0].hotel_code);
    }, [
        hotels
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                direction: "column",
                w: "100%",
                justify: "space-between",
                gap: 4,
                letterSpacing: "wide",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        direction: "column",
                        gap: 4,
                        color: "blackAlpha.700",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                h: [
                                    "30vh",
                                    null,
                                    null,
                                    "42vh"
                                ],
                                w: "100%",
                                position: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    alt: "",
                                    src: img,
                                    objectFit: "cover",
                                    priority: true,
                                    unoptimized: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                as: "h2",
                                fontWeight: 400,
                                fontSize: "xl",
                                letterSpacing: 4,
                                color: "black",
                                mt: 3,
                                className: "max-text-1-line",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                children: [
                                    !isGroupOffer && isParador && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        fontSize: "sm",
                                        textTransform: "capitalize",
                                        children: hotel1
                                    }),
                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                        fontSize: "sm",
                                        children: [
                                            locale == "id" ? "Harga mulai " : "Start from ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (0,functions/* formatRupiah */.b7)(price)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                fontSize: "sm",
                                letterSpacing: 0.2,
                                lineHeight: 1.2,
                                children: desc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        gap: 4,
                        children: [
                            price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                ref: optionRef,
                                position: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Button */.zxk, {
                                        variant: "dark",
                                        bg: color,
                                        borderColor: color,
                                        _hover: {
                                            border: "1px solid ".concat(color),
                                            color: color,
                                            bg: "white"
                                        },
                                        onClick: function() {
                                            isGroupOffer ? setShowOptions(!showOptions) : connect_to_synxis == "false" ? window.open(promo_url, "_blank") : function() {
                                                var targetCode = hotelCode !== null && hotelCode !== void 0 ? hotelCode : hotelCode2;
                                                var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                (0,functions/* submitBookingEngineForm */.Sw)({
                                                    action: action,
                                                    fields: {
                                                        language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                        arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                        nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                        guestCountSelector: "ReadOnly",
                                                        crossSell: "false",
                                                        selectedAdultCount: "2",
                                                        rate: rate !== null && rate !== void 0 ? rate : "",
                                                        promo: promo !== null && promo !== void 0 ? promo : "",
                                                        coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                    }
                                                });
                                            }();
                                        },
                                        children: [
                                            locale == "id" ? "Pesan" : "Book Now",
                                            isGroupOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronDown */.CgR, {
                                                style: {
                                                    marginLeft: 4
                                                },
                                                size: 14
                                            })
                                        ]
                                    }),
                                    hotels && isGroupOffer && showOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                        position: "absolute",
                                        left: 0,
                                        top: 12,
                                        flexDir: "column",
                                        bg: "white",
                                        className: "header-box-shadows",
                                        gap: 2,
                                        p: 3,
                                        overflowY: "scroll",
                                        maxH: 200,
                                        zIndex: 5,
                                        w: "max-content",
                                        children: hotel1 ? hotel1.map(function(name) {
                                            var tempHotel = (0,lodash.filter)(hotels, function(o) {
                                                return o.name == name;
                                            });
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            cursor: "pointer",
                                                            width: "100%",
                                                            wordBreak: "keep-all"
                                                        },
                                                        onClick: function() {
                                                            setShowOptions(false);
                                                            connect_to_synxis == "false" ? window.open(promo_url, "_blank") : function() {
                                                                var ref;
                                                                var targetCode = (ref = tempHotel[0]) === null || ref === void 0 ? void 0 : ref.hotel_code;
                                                                var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                                var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                (0,functions/* submitBookingEngineForm */.Sw)({
                                                                    action: action,
                                                                    fields: {
                                                                        language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                        arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                        nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                                        guestCountSelector: "ReadOnly",
                                                                        crossSell: "false",
                                                                        selectedAdultCount: "2",
                                                                        rate: rate !== null && rate !== void 0 ? rate : "",
                                                                        promo: promo !== null && promo !== void 0 ? promo : "",
                                                                        coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                    }
                                                                });
                                                            }();
                                                        },
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                        w: "full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                            orientation: "horizontal"
                                                        })
                                                    })
                                                ]
                                            }, name);
                                        }) : hotels.map(function(hotel) {
                                            var tempHotel = JSON.stringify(hotel);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            cursor: "pointer",
                                                            width: "100%",
                                                            wordBreak: "keep-all"
                                                        },
                                                        onClick: function() {
                                                            setShowOptions(false);
                                                            connect_to_synxis == "false" ? window.open(promo_url, "_blank") : function() {
                                                                var targetCode = hotel.hotel_code;
                                                                var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                                var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                (0,functions/* submitBookingEngineForm */.Sw)({
                                                                    action: action,
                                                                    fields: {
                                                                        language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                        arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                        nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                                        guestCountSelector: "ReadOnly",
                                                                        crossSell: "false",
                                                                        selectedAdultCount: "2",
                                                                        rate: rate !== null && rate !== void 0 ? rate : "",
                                                                        promo: promo !== null && promo !== void 0 ? promo : "",
                                                                        coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                    }
                                                                });
                                                            }();
                                                        },
                                                        children: hotel.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                            orientation: "horizontal"
                                                        })
                                                    })
                                                ]
                                            }, hotel.name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                variant: "outlineWhite",
                                color: color,
                                _hover: {
                                    bg: color,
                                    color: "white"
                                },
                                borderColor: color,
                                onClick: function() {
                                    category == "others" ? router.push(promo_url) : isGroupOffer ? setIsGroupPop(true) : router.push("/special-offers/".concat(id));
                                },
                                children: locale == "id" ? "Lebih Lengkap" : "See More"
                            })
                        ]
                    })
                ]
            }),
            isGroupPop1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGroupPopup, {
                hotelName: hotel1,
                color: color,
                id: id,
                isGroupOffer: isGroupOffer,
                hotelCode: isGroupOffer,
                setIsGroupPop: function(isGroupPop) {
                    return setIsGroupPop(isGroupPop);
                }
            })
        ]
    });
}
function OfferCardList(param) {
    var img = param.img, thumb_list = param.thumb_list, title = param.title, price = param.price, desc = param.desc, hotel2 = param.hotel, isGroupOffer = param.isGroupOffer, id = param.id, color = param.color, isParador = param.isParador, hotelCode = param.hotelCode, rate = param.rate, promo = param.promo, connect_to_synxis = param.connect_to_synxis, promo_url = param.promo_url, coupon = param.coupon, dest = param.dest, arrive = param.arrive, depart = param.depart, category = param.category;
    var router = (0,next_router.useRouter)();
    var locale = (0,hooks/* useLocale */.bU)();
    var ref10 = (0,react.useState)(false), isGroupPop2 = ref10[0], setIsGroupPop = ref10[1];
    var hotels = (0,hooks/* useGetListHotel */.e7)().hotels;
    var optionRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: optionRef,
        handler: function() {
            return setShowOptions(false);
        }
    });
    var ref8 = (0,react.useState)(false), showOptions = ref8[0], setShowOptions = ref8[1];
    var ref9 = (0,react.useState)(), hotelCode2 = ref9[0], setHotelCode2 = ref9[1];
    (0,react.useEffect)(function() {
        if (isGroupOffer || !isParador || !hotels) return;
        var tempHotel = (0,lodash.filter)(hotels, function(o) {
            return o.name == hotel2;
        });
        setHotelCode2(tempHotel[0].hotel_code);
    }, [
        hotels
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                h: "100%",
                w: "100%",
                gap: 8,
                letterSpacing: "wide",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        h: "60vh",
                        w: "60%",
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            alt: "",
                            src: thumb_list != null ? thumb_list : img,
                            objectFit: "cover",
                            priority: true,
                            unoptimized: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        w: "40%",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            direction: "column",
                            gap: 4,
                            color: "blackAlpha.700",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                    as: "h2",
                                    fontWeight: 400,
                                    fontSize: "xl",
                                    letterSpacing: 4,
                                    color: "black",
                                    mt: 3,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                    children: [
                                        !isGroupOffer && isParador && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            fontSize: "sm",
                                            textTransform: "capitalize",
                                            children: hotel2
                                        }),
                                        price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                            fontSize: "sm",
                                            children: [
                                                locale == "id" ? "Harga mulai " : "Start from ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: (0,functions/* formatRupiah */.b7)(price)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                    fontSize: "sm",
                                    letterSpacing: 0.2,
                                    lineHeight: 1.2,
                                    children: desc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    gap: 4,
                                    mt: 4,
                                    children: [
                                        price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                            ref: optionRef,
                                            position: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Button */.zxk, {
                                                    variant: "dark",
                                                    bg: color,
                                                    borderColor: color,
                                                    onClick: function() {
                                                        isGroupOffer ? setShowOptions(!showOptions) : connect_to_synxis == "false" ? window.open(promo_url, "_blank") : function() {
                                                            var targetCode = hotelCode !== null && hotelCode !== void 0 ? hotelCode : hotelCode2;
                                                            var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                            var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                            (0,functions/* submitBookingEngineForm */.Sw)({
                                                                action: action,
                                                                fields: {
                                                                    language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                    arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                    nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                                    guestCountSelector: "ReadOnly",
                                                                    crossSell: "false",
                                                                    selectedAdultCount: "2",
                                                                    rate: rate !== null && rate !== void 0 ? rate : "",
                                                                    promo: promo !== null && promo !== void 0 ? promo : "",
                                                                    coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                }
                                                            });
                                                        }();
                                                    },
                                                    children: [
                                                        locale == "id" ? "Pesan" : "Book Now",
                                                        isGroupOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronDown */.CgR, {
                                                            style: {
                                                                marginLeft: 4
                                                            },
                                                            size: 14
                                                        })
                                                    ]
                                                }),
                                                hotels && isGroupOffer && showOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 12,
                                                    flexDir: "column",
                                                    bg: "white",
                                                    className: "header-box-shadows",
                                                    gap: 2,
                                                    p: 3,
                                                    overflowY: "scroll",
                                                    maxH: 200,
                                                    zIndex: 5,
                                                    children: hotel2 ? hotel2.map(function(name) {
                                                        var tempHotel = (0,lodash.filter)(hotels, function(o) {
                                                            return o.name == name;
                                                        });
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                    as: "span",
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: function() {
                                                                        setShowOptions(false);
                                                                        connect_to_synxis == "false" ? window.open(promo_url, "_blank") : function() {
                                                                            var ref;
                                                                            var targetCode = (ref = tempHotel[0]) === null || ref === void 0 ? void 0 : ref.hotel_code;
                                                                            var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                                            var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                            (0,functions/* submitBookingEngineForm */.Sw)({
                                                                                action: action,
                                                                                fields: {
                                                                                    language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                                    arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                                    nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                                                    guestCountSelector: "ReadOnly",
                                                                                    crossSell: "false",
                                                                                    selectedAdultCount: "2",
                                                                                    rate: rate !== null && rate !== void 0 ? rate : "",
                                                                                    promo: promo !== null && promo !== void 0 ? promo : "",
                                                                                    coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                                }
                                                                            });
                                                                        }();
                                                                    },
                                                                    children: name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                                        orientation: "horizontal"
                                                                    })
                                                                })
                                                            ]
                                                        }, name);
                                                    }) : hotels.map(function(hotel) {
                                                        var tempHotel = JSON.stringify(hotel);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                                    as: "span",
                                                                    value: tempHotel,
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: function() {
                                                                        setShowOptions(false);
                                                                        connect_to_synxis == "false" ? window.open(promo_url, "_blank") : function() {
                                                                            var targetCode = hotel.hotel_code;
                                                                            var cfg = (0,functions/* getBookingEngineHotelConfig */.Np)(targetCode);
                                                                            var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                            (0,functions/* submitBookingEngineForm */.Sw)({
                                                                                action: action,
                                                                                fields: {
                                                                                    language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                                                                                    arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                                    nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                                                                                    guestCountSelector: "ReadOnly",
                                                                                    crossSell: "false",
                                                                                    selectedAdultCount: "2",
                                                                                    rate: rate !== null && rate !== void 0 ? rate : "",
                                                                                    promo: promo !== null && promo !== void 0 ? promo : "",
                                                                                    coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                                }
                                                                            });
                                                                        }();
                                                                    },
                                                                    children: hotel.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                                                        orientation: "horizontal"
                                                                    })
                                                                })
                                                            ]
                                                        }, hotel.name);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                            variant: "outlineWhite",
                                            color: color,
                                            _hover: {
                                                bg: color,
                                                color: "white"
                                            },
                                            borderColor: color,
                                            onClick: function() {
                                                category == "others" ? router.push(promo_url) : isGroupOffer ? setIsGroupPop(true) : router.push("/special-offers/".concat(id));
                                            },
                                            children: locale == "id" ? "Lebih Lengkap" : "See More"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            isGroupPop2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGroupPopup, {
                hotelName: hotel2,
                color: color,
                id: id,
                isGroupOffer: isGroupOffer,
                hotelCode: isGroupOffer,
                setIsGroupPop: function(isGroupPop) {
                    return setIsGroupPop(isGroupPop);
                }
            })
        ]
    });
}


/***/ })

}]);